export enum ListMode {
  LIST = "LIST",
  EDIT_FISHERY = "EDIT_FISHERY",
  ADD_FISHERY = "ADD_FISHERY",
}
